import { NFe4_00, ProtNFe4_00 } from '../model/nfe_4.0.0.model';

export class XMLtoNFe {
  private xmlDoc: Document;
  private domParse: DOMParser;
  private nfe: NFe4_00;
  private protNfe: ProtNFe4_00;

  constructor(xml: string) {
    this.domParse = new DOMParser();
    this.xmlDoc = this.domParse.parseFromString(xml, 'text/xml');
    this.nfe = new NFe4_00();
    this.protNfe = new ProtNFe4_00();
  }

  private parseIde(): void {
    const ideTag = this.xmlDoc.getElementsByTagName('ide')[0];
    this.nfe.ide.serie = this.getItem(ideTag, 'serie');
    this.nfe.ide.nNF = this.getItem(ideTag, 'nNF');
    this.nfe.ide.dhEmi = this.getItem(ideTag, 'dhEmi');
    this.nfe.ide.tpNF = this.getItem(ideTag, 'tpNF');
    this.nfe.ide.tpAmb = this.getItem(ideTag, 'tpAmb');
    this.nfe.ide.dhSaiEnt = this.getItem(ideTag, 'dhSaiEnt');
  }

  private parseEmit(): void {
    const emitTag = this.xmlDoc.getElementsByTagName('emit')[0];
    this.nfe.emit.xFant = this.getItem(emitTag, 'xFant');
    this.nfe.emit.xNome = this.getItem(emitTag, 'xNome');
    this.nfe.emit.CNPJ = this.getItem(emitTag, 'CNPJ');
    this.nfe.emit.CPF = this.getItem(emitTag, 'CPF');
    this.nfe.emit.IE = this.getItem(emitTag, 'IE');
    this.nfe.emit.CRT = this.getItem(emitTag, 'CRT');

    const enderTag = emitTag.getElementsByTagName('enderEmit')[0];

    this.nfe.emit.enderEmit.CEP = this.getItem(enderTag, 'CEP');
    this.nfe.emit.enderEmit.xLgr = this.getItem(enderTag, 'xLgr');
    this.nfe.emit.enderEmit.UF = this.getItem(enderTag, 'UF');
    this.nfe.emit.enderEmit.xMun = this.getItem(enderTag, 'xMun');
    this.nfe.emit.enderEmit.xBairro = this.getItem(enderTag, 'xBairro');
    this.nfe.emit.enderEmit.nro = this.getItem(enderTag, 'nro');
    this.nfe.emit.enderEmit.fone = this.getItem(enderTag, 'fone');
  }

  private parseDest(): void {
    const destTag = this.xmlDoc.getElementsByTagName('dest')[0];
    if(destTag){
      this.nfe.dest.xNome = this.getItem(destTag, 'xNome');
      this.nfe.dest.CNPJ = this.getItem(destTag, 'CNPJ');
      this.nfe.dest.CPF = this.getItem(destTag, 'CPF');
      this.nfe.dest.IE = this.getItem(destTag, 'IE');

      const enderTag = destTag.getElementsByTagName('enderDest')[0];

      this.nfe.dest.enderDest.xLgr = this.getItem(enderTag, 'xLgr');
      this.nfe.dest.enderDest.xMun = this.getItem(enderTag, 'xMun');
      this.nfe.dest.enderDest.nro = this.getItem(enderTag, 'nro');
      this.nfe.dest.enderDest.xBairro = this.getItem(enderTag, 'xBairro');
      this.nfe.dest.enderDest.UF = this.getItem(enderTag, 'UF');
    }
  }

  private parseDet(): void {
    const det = [];
    const totalDet = this.xmlDoc.getElementsByTagName('det');
    Array.from(totalDet).forEach(element => {
      det.push({
        nItem: element.getAttribute('nItem'),
        prod: {
          cProd: this.getItem(element, 'cProd'),
          cEAN:
            this.getItem(element, 'cEAN') === 'SEM GTIN'
              ? null
              : this.getItem(element, 'cEAN'),
          qCom: this.getItem(element, 'qCom'),
          cEANTrib:
            this.getItem(element, 'cEANTrib') === 'SEM GTIN'
              ? null
              : this.getItem(element, 'cEANTrib'),
          xProd: this.getItem(element, 'xProd'),
          NCM: this.getItem(element, 'NCM'),
          CFOP: this.getItem(element, 'CFOP'),
          uCom: this.getItem(element, 'uCom'),
          qTrib: this.getItem(element, 'qTrib'),
          vUnTrib: this.getItem(element, 'vUnTrib'),
          vProd: this.getItem(element, 'vProd'),
          vUnCom: this.getItem(element, 'vUnCom')
        },
        // imposto: {
        //   vTotTrib: element.getElementsByTagName('vTotTrib')[0].innerHTML,
        //   ICMS: {
        //     ICMS00: {
        //       CST: element.getElementsByTagName('CST')[0].innerHTML,
        //       vBC: element.getElementsByTagName('vBC')[0].innerHTML,
        //       pICMS: element.getElementsByTagName('pICMS')[0].innerHTML,
        //       vICMS: element.getElementsByTagName('vICMS')[0].innerHTML
        //     }
        //   },
        //   IPI: {
        //     cEnq: element.getElementsByTagName('cEnq')[0].innerHTML,
        //     IPINT: {
        //       CST: element.getElementsByTagName('CST')[0].innerHTML,
        //     }
        //   },
        //   PIS: {
        //     PISAliq: {
        //       CST: element.getElementsByTagName('CST')[0].innerHTML,
        //       vBC: element.getElementsByTagName('vBC')[0].innerHTML,
        //       pPIS: element.getElementsByTagName('pPIS')[0].innerHTML,
        //       vPIS: element.getElementsByTagName('vPIS')[0].innerHTML
        //     }
        //   },
        //   COFINS: {
        //     COFINSAliq: {
        //       CST: element.getElementsByTagName('CST')[0].innerHTML,
        //       vBC: element.getElementsByTagName('vBC')[0].innerHTML,
        //       pCOFINS: element.getElementsByTagName('pCOFINS')[0].innerHTML,
        //       vCOFINS: element.getElementsByTagName('vCOFINS')[0].innerHTML
        //     }
        //   },
        // }
      });
    });
    this.nfe.det = det;
  }

  private parseTotal(): void {
    const totalTag = this.xmlDoc.getElementsByTagName('total')[0];
    this.nfe.total.vBC = this.getItem(totalTag, 'vBC');
    this.nfe.total.vICMS = this.getItem(totalTag, 'vICMS');
    this.nfe.total.vNF = this.getItem(totalTag, 'vNF');
    this.nfe.total.vOutro = this.getItem(totalTag, 'vOutro');
    this.nfe.total.vDesc = this.getItem(totalTag, 'vDesc');
    this.nfe.total.vFrete = this.getItem(totalTag, 'vFrete');
    this.nfe.total.vTotTrib = this.getItem(totalTag, 'vTotTrib');
  }

  private parseInfNfeSupl(): void {
    const infNFeSupl = this.xmlDoc.getElementsByTagName('infNFeSupl')[0];
    this.nfe.infNfeSupl.qrCode = this.getItem(infNFeSupl, 'qrCode');
    this.nfe.infNfeSupl.urlChave = this.getItem(infNFeSupl, 'urlChave');
  }

  private parsePag(): void {
    const pags = [];
    const pag = this.xmlDoc.getElementsByTagName('pag')[0];
    const totalPags = this.xmlDoc.getElementsByTagName('detPag');
    Array.from(totalPags).forEach(element => {
      pags.push({
        detPag: {
          indPag: this.getItem(element, 'indPag'),
          tPag: this.getItem(element, 'tPag'),
          vPag: this.getItem(element, 'vPag')
        }
      });
    });

    this.nfe.pag = {detPag: pags, vTroco: this.getItem(pag, 'vTroco')};
  }

  private getItem(element: Element, tag: string) {
    try {
      return element.getElementsByTagName(tag)[0].innerHTML;
    } catch (err) {
      return null;
    }
  }

  public parse(): NFe4_00 {
    this.nfe.Id = this.xmlDoc
      .getElementsByTagName('infNFe')[0]
      .getAttribute('Id');
    this.parseIde();
    this.parseEmit();
    this.parseDest();
    this.parseDet();
    this.parseTotal();
    this.parseInfNfeSupl();
    this.parsePag();
    return this.nfe;
  }

  public parseProtNfe(): ProtNFe4_00 {
    const protocolo = this.xmlDoc.getElementsByTagName('protNFe')[0];
    const infProt = protocolo.getElementsByTagName('infProt')[0];
    this.protNfe = {infProt: {
      chNFe: this.getItem(infProt, 'chNFe'),
      cStat: this.getItem(infProt, 'cStat'),
      dhRecbto: this.getItem(infProt, 'dhRecbto'),
      digVal: this.getItem(infProt, 'digVal'),
      nProt: this.getItem(infProt, 'nProt'),
      tpAmb: this.getItem(infProt, 'tpAmb'),
      verAplic: this.getItem(infProt, 'verAplic'),
      xMotivo: this.getItem(infProt, 'xMotivo')
    }};

    return this.protNfe;
  }
}
